module.exports = __webpack_public_path__ + "img/chart-line-icon-light.e1ec13b3.svg";